/**
 * ColorinKids – AJAX Cart
 * assets/colorinkids-cart.js
 *
 * Maneja:
 * - Agregar al carrito sin recargar la página (Shopify Cart API)
 * - Actualizar el contador del carrito en el header
 * - Mostrar feedback visual en el botón
 *
 * Compatible con Shopify Horizon y cualquier tema que use
 * el atributo [data-cart-count] para el contador.
 */

(function () {
  'use strict';

  /* ── Helpers ── */
  function updateCartCount(count) {
    // Horizon usa data-cart-count, también actualizamos data-count y texto
    document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('aria-label', count + ' productos en el carrito');
      if (count > 0) {
        el.removeAttribute('hidden');
        el.style.display = '';
      }
    });
  }

  function getCartCount() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { return cart.item_count; });
  }

  function setButtonState(btn, state) {
    btn.disabled = (state !== 'idle');
    btn.classList.toggle('ck-btn-atc--loading', state === 'loading');
    btn.classList.toggle('ck-btn-atc--added',   state === 'added');

    if (state === 'added') {
      var textEl = btn.querySelector('.ck-btn-atc__text');
      if (textEl) {
        textEl.dataset.original = textEl.dataset.original || textEl.textContent;
        textEl.textContent = '✓ Agregado';
      }
    } else if (state === 'idle') {
      var textEl = btn.querySelector('.ck-btn-atc__text');
      if (textEl && textEl.dataset.original) {
        textEl.textContent = textEl.dataset.original;
      }
    }
  }

  function addToCart(variantId, quantity, btn) {
    setButtonState(btn, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Error al agregar al carrito');
      return res.json();
    })
    .then(function () {
      setButtonState(btn, 'added');

      // Actualizar contador
      return getCartCount();
    })
    .then(function (count) {
      updateCartCount(count);

      // Abrir el drawer del carrito si Horizon lo tiene
      document.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Volver al estado normal después de 2s
      setTimeout(function () { setButtonState(btn, 'idle'); }, 2000);
    })
    .catch(function (err) {
      console.error('[ColorinKids] Cart error:', err);
      setButtonState(btn, 'idle');

      // Fallback: mostrar mensaje de error accesible
      var msg = document.createElement('p');
      msg.textContent = 'Ocurrió un error. Por favor, intentá de nuevo.';
      msg.style.cssText = 'color:red;font-size:12px;margin-top:4px;';
      msg.setAttribute('role', 'alert');
      btn.parentNode.insertBefore(msg, btn.nextSibling);
      setTimeout(function () { msg.remove(); }, 4000);
    });
  }

  /* ── Event delegation: escucha clics en todos los botones ATC ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ck-btn-atc[data-variant-id]');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    addToCart(parseInt(variantId, 10), 1, btn);
  });

  /* ── Al cargar la página, sincronizar el contador ── */
  document.addEventListener('DOMContentLoaded', function () {
    getCartCount()
      .then(updateCartCount)
      .catch(function () { /* silencioso si no hay sesión */ });
  });

})();
